import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

import { AreaUnit } from 'src/app/shared/enums/AreaUnit.enum';
import { CustomFieldsGroupNameType } from 'src/app/shared/enums/CustomFieldsType.enum';
import { isNullOrUndefined } from '../../../../../shared/TerraUtils';
import { LpAssetReqRes } from '../../../LpAssetReqRes.model';
import { AssetDetailsDialogComponent } from './asset-details-dialog/asset-details-dialog.component';

@Component({
  selector: 'terra-asset-details-section',
  templateUrl: './asset-details-section.component.html',
  styleUrls: ['../../../../styles/holding/holding-page-shared.scss', './asset-details-section.component.scss'],
})
export class AssetDetailsSectionComponent implements OnInit, OnChanges {
  @Input() asset: LpAssetReqRes;
  @Input() isPhonePreview = false;
  @Output() toDisplay = new EventEmitter<boolean>();

  displayDetails$ = new BehaviorSubject(true);
  assetDetailsValuesCount$ = new BehaviorSubject(0);
  customDetails = signal<Array<{ id: number, name: string;  value: string;}>>([]);

  // Enums
  AreaUnit = AreaUnit;

  private readonly matDialog: MatDialog = inject(MatDialog);

  ngOnInit() {
    this.displayData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.asset) {
      const valuesCount = this.getAssetDetailsValuesCount();
      this.displayDetails$.next(valuesCount > 0);
      this.assetDetailsValuesCount$.next(valuesCount);
    }
  }

  showAll() {
    const dialogConfig = new MatDialogConfig<LpAssetReqRes>();
    dialogConfig.disableClose = false;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '100vw';
    dialogConfig.maxWidth = '600px';
    dialogConfig.height = '100vh';
    dialogConfig.maxHeight = '800px';
    dialogConfig.panelClass = 'info-dialog';
    dialogConfig.panelClass = this.isPhonePreview ? 'info-dialog-no-shadow' : 'info-dialog';

    dialogConfig.data = this.asset;
    this.matDialog.open(AssetDetailsDialogComponent, dialogConfig);
  }

  private getAssetDetailsValuesCount(): number {
    if (!this.asset) {
      return null;
    }

    let count = 0;
    const ad = this.asset;

    const propsToCheck = [
      ad.lotSizeArea, ad.stories, ad.residentialUnits,
      ad.retailUnits, ad.rooms, ad.grossBuildingArea,
      ad.residentialNetSellableArea, ad.retailNetSellableArea,
      ad.numberOfSites];

    propsToCheck.forEach(prop => {
      if (!(prop === null || prop === undefined)) {
        count++;
      }
    });

    this.customDetails.set(
      this.asset.customFields?.filter(({groupName}) => groupName === CustomFieldsGroupNameType.AssetOptionalDetail)
        .map(({id, fieldName, fieldValue}) => ({
          id,
          name: fieldName,
          value: fieldValue
        }))
    )

    count = count + this.customDetails().length;
    return count;
  }

  displayData(): void {
    this.toDisplay.next(
      !isNullOrUndefined(this.asset.lotSizeArea) || !isNullOrUndefined(this.asset.stories) ||
      !isNullOrUndefined(this.asset.residentialUnits) || !isNullOrUndefined(this.asset.retailUnits) ||
      !isNullOrUndefined(this.asset.rooms) || !isNullOrUndefined(this.asset.grossBuildingArea) ||
      !isNullOrUndefined(this.asset.residentialNetSellableArea) || !isNullOrUndefined(this.asset.retailNetSellableArea) ||
      !isNullOrUndefined(this.asset.numberOfSites) || !isNullOrUndefined(this.asset.customFields)
    );
  }
}
